<template>
    <v-card outlined elevation="0" tile>
        <v-card-text>
            <Divisa :params="params" :loading.sync="loading"/>
        </v-card-text>
        <v-card-text>
            <Juego :params="params" :loading.sync="loading"/>
        </v-card-text>
    </v-card>
</template>

<script>

import Divisa from './divisa.vue';
import Juego from './juego.vue';

export default {
    components: {
        Divisa,
        Juego
    },
    props: {
        params: {
            defaults: function() {
                return {};
            },
        },
    },
    data: function () {
        return {
            loading: false,
        };
    },
    methods: {
    },
    watch: {
        'loading': function (loading) {
            this.$emit('update:loading', loading);
        }
    }
}
</script>